import { useMovements } from '@/api/hooks';
import { MovementFormModal } from '@/components/movements/MovementFormModal';
import { Badge } from '@/components/ui/Badge';
import { Button } from '@/components/ui/Button';
import { Card, CardBody } from '@/components/ui/Card';
import { ListPagination } from '@/components/ui/ListPagination';
import { PageHeader } from '@/components/ui/PageHeader';
import { usePropertyScope } from '@/contexts/PropertyContext';
import { formatDate, movementTypeLabel } from '@/lib/format';
import { Plus } from 'lucide-react';
import { useEffect, useState } from 'react';

export function MovementsPage() {
  const { propertyId } = usePropertyScope();
  const [page, setPage] = useState(1);
  const { data, isLoading } = useMovements({
    property_id: propertyId ?? undefined,
    page,
  });
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setPage(1);
  }, [propertyId]);

  const lastPage = data?.meta.last_page ?? 1;

  return (
    <div>
      <PageHeader
        title="Movimentações"
        subtitle="Transferências, vendas e mortes"
        actions={
          <Button onClick={() => setOpen(true)} disabled={!propertyId}>
            <Plus className="h-4 w-4" />
            Nova movimentação
          </Button>
        }
      />

      {!propertyId ? (
        <Card><CardBody className="py-10 text-center text-manejai-bark/60">Selecione uma propriedade.</CardBody></Card>
      ) : isLoading ? (
        <div className="h-32 rounded-2xl bg-manejai-sand/40 animate-pulse" />
      ) : (
        <Card>
          <ul className="divide-y divide-manejai-sand/60">
            {(data?.movements ?? []).map((m) => (
              <li key={m.id} className="px-5 py-4 flex justify-between items-center">
                <div>
                  <p className="font-medium text-manejai-forest">{movementTypeLabel(m.movement_type)}</p>
                  <p className="text-xs text-manejai-bark/60">{formatDate(m.movement_date)} · {m.scope}</p>
                </div>
                <Badge>{m.movement_type}</Badge>
              </li>
            ))}
            {(data?.movements.length ?? 0) === 0 && (
              <li className="px-5 py-12 text-center text-manejai-bark/60">Nenhuma movimentação.</li>
            )}
          </ul>
          <ListPagination
            page={page}
            lastPage={lastPage}
            summary={`${data?.meta.total ?? 0} movimentação(ões) no total`}
            onPageChange={setPage}
          />
        </Card>
      )}

      {propertyId && <MovementFormModal open={open} onClose={() => setOpen(false)} propertyId={propertyId} />}
    </div>
  );
}
